import styled from 'styled-components';
import DriverDayStop from './component';

import { skinsGroupage } from 'modules/journey/card/styled/groupageBackground';

export default styled(DriverDayStop)`
  min-height: 68px;
  background-color: var(--grey100);
  width: 100%;

  .container {
    background-color: #fff;
    width: 752px;
    display: flex;
    width: 100%;
  }

  .cell {
    background-color: #fff;
    &__skin {
      background: ${(props) => skinsGroupage[props.skin]};
    }
    &__nogrow {
      flex: 0;
    }
    &__right {
      text-align: right;
    }
    &__padding {
      padding: 8px;
    }
    &__grow {
      flex: 1;
    }
    &__dark {
      background-color: var(--grey100);
      color: var(--grey700);
    }
  }

  .stop-timings {
    padding: 0;
    position: relative;
    height: 100%;

    &:before {
      content: '';
      position: absolute;
      width: 4px;
      top: 0;
      background-color: var(--primary300);
      left: 14px;
      height: 8px;
    }

    &:after {
      content: '';
      width: 4px;
      position: absolute;
      top: 40px;
      background-color: var(--primary300);
      left: 14px;
      bottom: 0;
    }

    &__first_stop {
      &:before {
        display: none;
      }
    }

    &__last_stop {
      &:after {
        display: none;
      }
    }

    &__starts_empty {
      &:before {
        background-color: transparent;
        border: 2px dotted var(--grey300);
      }
    }

    &__ends_empty {
      &:after {
        background-color: transparent;
        border: 2px dotted var(--grey300);
      }
    }

    &__number {
      width: 32px;
      height: 32px;
      border: 4px solid var(--primary300);
      border-radius: 32px;
      background-color: #fff;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      top: 8px;
      left: 0;
      z-index: 2;
      font-weight: bold;
    }

    &__filled {
      .stop-timings__number {
        background-color: var(--primary300);
        color: #fff;
      }
    }

    &__times {
      position: absolute;
      background-color: var(--primary100);
      height: 32px;
      left: 0;
      border-radius: 32px;
      padding-left: 37px;
      display: flex;
      align-items: center;
      top: 8px;
      z-index: 1;
      width: 100%;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .problematic {
    background-color: var(--error500);
    border-radius: 2px;
    color: #fff;
    line-height: 18px;
    display: inline-block;
    padding: 0 4px;
  }

  .load {
    display: flex;
    margin-bottom: 4px;
    &__cell {
      margin-right: 8px;
      border-right: 1px solid var(--grey100);
      padding-right: 8px;
      &:last-child {
        border-right: 0;
      }
    }
    &__right {
      text-align: right;
    }
  }

  .extras {
    display: flex;
  }

  .extra {
    width: 26px;
    margin-right: 8px;
    &:last-child {
      margin-right: 0;
    }
  }

  .actions-button {
    height: 28px;
    color: var(--primary900);
    border: 1px solid var(--primary300);
    border-radius: 4px;
    font-weight: bold;
    font-size: 12px;
    cursor: pointer;
    padding: 0 8px;
    outline: none;
    background: #fff;
    overflow: hidden;
    display: block;
    text-align: none;
    &[disabled] {
      opacity: 0.5;
    }
  }
`;
